import React from "react";
import Aboutme from "./Aboutme";
import Skill from "./skills";


const About = () => {

    return (
        <div>
            <Aboutme />
            <Skill />
        </div>
    )
}

export default About